import { render, staticRenderFns } from "./ResList.vue?vue&type=template&id=4d28f12e&scoped=true"
import script from "./ResList.vue?vue&type=script&lang=js"
export * from "./ResList.vue?vue&type=script&lang=js"
import style0 from "./ResList.vue?vue&type=style&index=0&id=4d28f12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28f12e",
  null
  
)

export default component.exports